<meta-content-preview [contentType]="'guide'" [cover]="guide.image" [title]="guide.title"
    [description]="guide.description" [showImage]="true" [showDescription]="true" />